import { toast } from "@/components/ui/use-toast";

const capitalize = (s: string) => s.charAt(0).toUpperCase() + s.slice(1);

export const hubToast = {
  sent: (entityType: string) => {
    const label = capitalize(entityType);
    toast({
      title: `${label} sent`,
      description: `Your ${entityType} was successfully sent to teen`,
    });
  },

  deleted: (entityType: string) => {
    const label = capitalize(entityType);
    toast({
      title: `${label} deleted`,
      description: `Your ${entityType} was successfully deleted`,
    });
  },

  scheduleChanged: (entityType: string) => {
    const label = capitalize(entityType);
    toast({
      title: "Changed schedule",
      description: `${label} schedule was successfully changed`,
    });
  },

  scheduled: (entityType: string) => {
    const label = capitalize(entityType);
    toast({
      title: `${label} scheduled`,
      description: `Your ${entityType} has been scheduled`,
    });
  },

  error: (message: string) => {
    toast({
      title: "Error",
      description: message,
      variant: "destructive",
    });
  },
};
